<template>
  <div
    class="hero is-fullheight fullpage-section"
    data-anchor="section-productos"
  >
    <div class="columns">
      <div class="column is-half-desktop">
        <div class="column is-half is-hidden-mobile" style="height: 15vh"></div>
        <div
          class="column is-7 is-offset-4 is-centered slides-style slides-style-mobile background-productos "
          align="center"
        >
          <div class="columns">
            <div class="column padding-top-off">
              <nav
                class="pagination is-4-desktop is-rounded is-centered"
                role="navigation"
                aria-label="pagination"
              >
                <a class="button img-flechas is-fixed-top">
                  <img
                    class="img-flechas is-paddingless transparent-background"
                    :src="getImg('productos/Flecha-Izquierda.png')"
                    v-on:click="
                      (indexProduct = (indexProduct - 1 + 3) % 3),
                        descriptionActualTxt()
                    "
                    alt
                  />
                </a>
                <ul class="column is-5-desktop is-paddingless">
                  <span
                    class="button swiper-pagination-bullet is-paddingless"
                    role="button"
                    v-on:click="(indexProduct = 0), descriptionActualTxt()"
                    v-bind:class="{ 'is-active': indexProduct === 0 }"
                    align="center"
                  ></span>
                  <span
                    class="button swiper-pagination-bullet is-paddingless"
                    role="button"
                    v-on:click="(indexProduct = 1), descriptionActualTxt()"
                    v-bind:class="{ 'is-active': indexProduct === 1 }"
                    align="center"
                  ></span>
                  <span
                    class="button swiper-pagination-bullet is-paddingless"
                    role="button"
                    v-on:click="(indexProduct = 2), descriptionActualTxt()"
                    v-bind:class="{ 'is-active': indexProduct === 2 }"
                    align="center"
                  ></span>
                </ul>
                <a class="button img-flechas is-fixed-top">
                  <img
                    class="img-flechas is-paddingless transparent-background"
                    :src="getImg('productos/Flecha-Derecha.png')"
                    v-on:click="
                      (indexProduct = (indexProduct + 1 + 3) % 3),
                        descriptionActualTxt()
                    "
                    alt
                  />
                </a>
              </nav>
              <div
                class="column"
                id="descriProduct"
                onload="descriptionActualTxt()"
              >
                <div class=" column">
                  <h2 class="has-font-unicone size-title">
                    FUNDAS
                  </h2>
                </div>
                <div class="column">
                  Cubierta cosmética anatómica que busca mejorar la
                  autopercepción y adherencia de la persona amputada en su
                  proceso de rehabilitación.
                </div>
                <div class="column">
                  Disponible para prótesis transtibiales y transfemorales.
                </div>
                <a href="https://fundas.calce.cl/">
                  <button
                    class="button is-hovered button-style is-hidden-mobile is-centered"
                  >
                    Obtén tu funda
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-half-desktop ">
        <div class="column is-half is-hidden-mobile" style="height: 15vh"></div>
        <div class="column" align="center">
          <img
            class="img-producto img-producto-mobile is-centered"
            :src="productoActualImg(indexProduct)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getImg } from "@/utils/AssetsHelper"

export default {
  created: function() {
    console.log(this.descriptionActualTxt())
  },
  methods: {
    getImg,
    productoActualImg(indexProduct) {
      return getImg(this.productos[indexProduct])
    },
    descriptionActualTxt() {
      document.getElementById("descriProduct").innerHTML = this.descriptionP[
        this.indexProduct
      ]
    }
  },
  data() {
    return {
      productos: [
        "productos/Silueta-Funda2.png",
        "productos/Silueta-Cavidad.png",
        "productos/Silueta-Máscara.png"
      ],
      descriptionP: [
        '<div class="column"><h2 style="font-size: 7vh;">FUNDAS</h2></div>\n' +
          '                  <div class=" column">\n' +
          "                  Cubierta cosmética anatómica que busca mejorar la\n" +
          "                  autopercepción y adherencia de la persona amputada en su\n" +
          "                  proceso de rehabilitación.\n" +
          "                  </div>\n" +
          '                  <div class=" column">\n' +
          "                  Disponible para prótesis transtibiales y transfemorales.\n" +
          "                  </div>" +
          '                <button class="button is-hovered is-hidden-mobile" ' +
          '                  style="background-color: transparent;color: #f39e52;' +
          '                  border-color: rgba(243, 158, 82, 0.48);border-width: thick;">\n' +
          "                  Obtén tu funda\n" +
          "                </button>",
        '<div class="column"><h2 style="font-size: 7vh;">CAVIDADES</h2></div>\n' +
          '                <div class=" column">\n' +
          "                  Pieza que une el muñon con el resto la prótesis de manera anatómica," +
          "                  a fin de que la persona recupere independencia en su desplazamiento." +
          "                </div>\n" +
          '                <div class=" column">\n' +
          "                  Nuestro servicio de cavidades duplica la capacidad productiva" +
          "                  en los institutos de rehabilitacion utilizado.\n" +
          "                </div>",
        '<div class="column"><h2 style="font-size: 7vh;">MÁSCARAS</h2></div>\n' +
          '                <div class=" column">\n' +
          "                  Dispositivo de compresión anatómico que contribuye en la regeneración" +
          "                  cutanea de personas quemadas y/o con heridas faciales.\n" +
          "                </div>",
      ],
      indexProduct: 0
    }
  }
}
</script>

<style scoped>
.img-producto {
  height: auto;
  width: 40vw;
}

@media screen and (max-width: 768px) {
  .img-producto-mobile {
    height: 40vh;
    width: auto;
  }
}

.slides-style {
  height: 85vh;
}

@media screen and (max-width: 768px) {
  .slides-style-mobile {
    height: 50vh;
  }
}

.button-style {
  background-color: transparent;
  color: #f39e52;
  border-color: rgba(243, 158, 82, 0.48);
  border-width: thick;
}
.swiper-pagination-bullet {
  width: 3vh;
  height: 3vh;
  opacity: 1;
  margin: 0 5% !important;
  border: #f39e52 solid 1mm;
  background-color: transparent;
}

.swiper-pagination-bullet.is-active {
  border: #f39e52 solid 3mm !important;
}

.swiper-pagination >>> .swiper-pagination-bullet-active {
  background-color: #f39e52;
}

.img-flechas {
  background: transparent;
  height: auto;
  width: 6vw;
  border: 0;
}

.background-productos {
  background-image: url("../../assets/img/productos/Rectangulo-de-fondo.png");
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
}

@media screen and (max-width: 768px) {
  .background-productos {
    background-image: url("../../assets/img/productos/Rectangulo-de-fondo2.png");
    background-size: cover;
  }
  .img-flechas {
    background: transparent;
    height: 10vh;
    width: auto;
    border: 0;
  }
}

.padding-top-off {
  padding-top: 0;
}

.font-title {
  font-family: "Unica One", sans-serif;
}

.size-title {
  font-size: 7vh;
}
</style>
